const domainWithoutWWWRegex = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g

export const replaceWWW = (domain: string): string => domain.replace(domainWithoutWWWRegex, '')

export const replaceWWWS = (domains: Array<string>): Array<string> =>
  domains.map((domain) => domain.replace(domainWithoutWWWRegex, ''))

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

type StringOrUndefined = string | undefined | null
export const compareStrings = (a: StringOrUndefined, b: StringOrUndefined) => {
  if (!a || !b) return false
  return a.toLowerCase() === b.toLowerCase()
}
